import { createFileRoute } from "@tanstack/react-router";
import { HospitalerPage, hospitalerHead } from "@/pages/HospitalerPage";

export const Route = createFileRoute("/de/branchen/krankenhaeuser-gesundheit")({
  head: () => hospitalerHead("de"),
  component: () => <HospitalerPage locale="de" />,
});
